import React from 'react'
import { find } from 'lodash'
import EcsLogoSvg from '../../assets/images/ecs_logo.svg'

export default ({clinic, data}) => {
  
  const missionStatement = find(data, (d) => {
    if (clinic) {
      return clinic.url === d.clinic
    }

    return !d.clinic
  })

  return (
    <div className="min-h-64 bg-white">
      
      <div className="max-w-6xl mx-auto px-4 py-16 min-h-64">
        <img src={EcsLogoSvg} className="w-[200px] h-auto mx-auto mb-8" />
        <div className="max-w-2xl mx-auto leading-10 lg:leading-[3rem] font-semibold text-xl lg:text-2xl text-center px-8">
          <div className="text-gray-500 font-light" dangerouslySetInnerHTML={{__html: missionStatement.body}}></div>
        </div>
      </div>
    </div>
  )
}